/**
 * 商品一覧カードの「＋（案件に追加）」ボタン → 案件へ素早く追加する軽量フロー
 * - PDPのフル「案件に追加」(add-to-project.js)は商品ページ限定。一覧カードの＋は無反応だったため本スクリプトで対応。
 * - カラー/生地の詳細選択は行わず、既定バリアントで追加（案件詳細ページで後から修正できる）。
 * - 依存API: GET /apps/quote/api/projects（一覧）／POST 同URL（新規作成）／POST /apps/quote/api/projects/:id/items（追加）
 * data属性: [data-project-add] data-product-id data-handle data-title data-image
 */
(function () {
  var API = '/apps/quote/api/projects';
  var current = null;
  var modal = null;

  // 会員情報が未登録（アプリが 403 profile_required を返す）なら登録画面へ。保存後はこのページへ戻る
  //（西澤さん 2026-10-08／snippets/profile-required-gate.liquid）
  function goProfileIfRequired(d) {
    if (!d || !d.profile_required) return false;
    if (window.aspGoProfileRegister) window.aspGoProfileRegister();
    else window.location.href = '/apps/quote/profile?first=1&return_to=' + encodeURIComponent(location.pathname + location.search);
    return true;
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function ensureModal() {
    if (modal) return modal;
    var style = document.createElement('style');
    style.textContent =
      '.qatp-overlay{position:fixed;inset:0;background:rgba(20,20,20,.45);display:flex;align-items:center;justify-content:center;z-index:99998;padding:16px}' +
      '.qatp-overlay[hidden]{display:none}' +
      '.qatp-box{background:#fff;max-width:640px;width:100%;border-radius:var(--radius-box-lg);overflow:hidden;box-shadow:0 12px 40px rgba(0,0,0,.2)}' +
      '.qatp-head{display:flex;align-items:center;justify-content:space-between;padding:16px 20px;border-bottom:1px solid #e5e0d8}' +
      '.qatp-head h2{margin:0;font-size:15px;letter-spacing:.04em}' +
      '.qatp-head button{background:none;border:none;font-size:22px;line-height:1;cursor:pointer;color:#8a8375}' +
      '.qatp-body{padding:16px 20px 20px}' +
      '.qatp-sub{font-size:12px;color:#8a8375;margin:0 0 10px}' +
      '.qatp-filter{width:100%;padding:9px 10px;border:1px solid #cfc7be;border-radius:var(--radius-box);font:inherit;font-size:14px;margin:0 0 10px;box-sizing:border-box}' +
      '.qatp-filter[hidden]{display:none}' +
      // CB260910⑦: ⑥のPDPモーダルと同じ絞り込みに合わせる（状態は追加できる3つだけ）
      '.qatp-controls{display:grid;grid-template-columns:1fr 128px;gap:8px;margin:0 0 10px}' +
      '.qatp-controls[hidden]{display:none}' +
      // 自分の案件／共有された案件の切替（案件一覧ページのタブと同じ分け方）
      '.qatp-tabs{display:flex;gap:20px;border-bottom:1px solid #e5e0d8;margin:0 0 12px}' +
      '.qatp-tabs[hidden]{display:none}' +
      '.qatp-tab{background:none;border:none;border-bottom:2px solid transparent;margin-bottom:-1px;padding:6px 0;font:inherit;font-size:13px;letter-spacing:.04em;color:#8a8375;cursor:pointer}' +
      '.qatp-tab.is-active{color:#2e2e2c;border-bottom-color:#2e2e2c}' +
      '.qatp-controls .qatp-filter{margin:0}' +
      '.qatp-status{width:100%;padding:9px 10px;border:1px solid #cfc7be;border-radius:var(--radius-box);font:inherit;font-size:14px;background:#fff;box-sizing:border-box}' +
      '.qatp-project-meta{display:block;margin-top:2px;font-size:12px;color:#8a8375}' +
      '.qatp-note{font-size:12px;line-height:1.5;color:#8a8375;margin:0 0 12px}' +
      '.qatp-note[hidden]{display:none}' +
      '@media (max-width:480px){.qatp-controls{grid-template-columns:1fr}}' +
      '.qatp-list{display:flex;flex-direction:column;gap:6px;max-height:min(480px,55svh);overflow:auto;margin-bottom:14px}' +
      '.qatp-project{text-align:left;background:#f7f5f1;border:1px solid #e5e0d8;border-radius:var(--radius-box);padding:10px 12px;font:inherit;font-size:14px;cursor:pointer;color:#2e2e2c}' +
      '.qatp-project:hover{background:#efece6}' +
      '.qatp-hint{font-size:13px;color:#8a8375;margin:4px 0}' +
      '.qatp-new{display:flex;gap:8px;border-top:1px solid #e5e0d8;padding-top:14px}' +
      '.qatp-new[hidden]{display:none}' +
      '.qatp-login{display:inline-block;padding:10px 16px;border-radius:var(--radius-box);background:#2e2e2c;color:#fff;font-size:13px;letter-spacing:.04em;text-decoration:none}' +
      '.qatp-login:hover{opacity:.85}' +
      '.qatp-new input{flex:1;padding:9px 10px;border:1px solid #cfc7be;border-radius:var(--radius-box);font:inherit;font-size:14px}' +
      '.qatp-new button{padding:9px 14px;border:none;border-radius:var(--radius-box);background:#2e2e2c;color:#fff;font:inherit;font-size:13px;cursor:pointer;white-space:nowrap}' +
      '.qatp-toast{position:fixed;bottom:24px;left:50%;transform:translateX(-50%);background:#1a1a1a;color:#fff;padding:12px 20px;border-radius:var(--radius-box);font-size:14px;z-index:99999}';
    document.head.appendChild(style);

    var el = document.createElement('div');
    el.className = 'qatp-overlay';
    el.hidden = true;
    el.innerHTML =
      '<div class="qatp-box" role="dialog" aria-modal="true" aria-label="案件に追加">' +
      '<div class="qatp-head"><h2 data-qatp-title>案件に追加</h2><button type="button" data-qatp-close aria-label="閉じる">&times;</button></div>' +
      '<div class="qatp-body">' +
      '<p class="qatp-sub">追加先の案件を選択してください。</p>' +
      '<div class="qatp-tabs" data-qatp-tabs role="tablist" hidden>' +
      '<button type="button" class="qatp-tab is-active" data-qatp-tab="own" role="tab" aria-selected="true">自分の案件 <span data-qatp-tab-count="own"></span></button>' +
      '<button type="button" class="qatp-tab" data-qatp-tab="shared" role="tab" aria-selected="false">共有された案件 <span data-qatp-tab-count="shared"></span></button>' +
      '</div>' +
      '<div class="qatp-controls" data-qatp-controls hidden>' +
      '<input type="text" class="qatp-filter" data-qatp-filter placeholder="案件名・会社名・担当者で検索" autocomplete="off">' +
      '<select class="qatp-status" data-qatp-status aria-label="状態で絞り込む">' +
      '<option value="">すべての状態</option>' +
      '<option value="draft">仮登録</option>' +
      '<option value="quoted">見積提出済</option>' +
      '<option value="revised">内容修正</option>' +
      '</select></div>' +
      '<div class="qatp-list" data-qatp-list></div>' +
      '<p class="qatp-note" data-qatp-note hidden></p>' +
      '<div class="qatp-new"><input type="text" data-qatp-new-name placeholder="新規案件名を入力" maxlength="200"><button type="button" data-qatp-create>作成して追加</button></div>' +
      '</div></div>';
    document.body.appendChild(el);
    modal = el;

    el.addEventListener('click', function (e) {
      if (e.target === el || (e.target.closest && e.target.closest('[data-qatp-close]'))) close();
    });
    el.querySelector('[data-qatp-create]').addEventListener('click', createAndAdd);
    var filter = el.querySelector('[data-qatp-filter]');
    if (filter) filter.addEventListener('input', function () { filterProjects(); });
    var statusSel = el.querySelector('[data-qatp-status]');
    if (statusSel) statusSel.addEventListener('change', function () { filterProjects(); });
    Array.prototype.forEach.call(el.querySelectorAll('[data-qatp-tab]'), function (t) {
      t.addEventListener('click', function () { setTab(t.getAttribute('data-qatp-tab')); });
    });
    return modal;
  }

  // CB260910⑦: 案件名・会社名・担当者の部分一致（大小文字無視）＋状態で絞り込み。該当0件は案内を表示。
  // 対象文字列と状態はレンダリング時にボタンのdata属性へ入れてある（textContent照合だと状態名にも当たってしまう）。
  // 案件一覧ページ（proxy.quote.tsx）の検索と同じ正規化＝NFKC（全角英数→半角）・小文字・ひらがな→カタカナ
  function normalizeSearch(s) {
    s = String(s == null ? '' : s).normalize('NFKC').toLowerCase();
    var out = '';
    for (var i = 0; i < s.length; i++) {
      var code = s.charCodeAt(i);
      if (code >= 0x3041 && code <= 0x3096) code += 0x60;
      out += String.fromCharCode(code);
    }
    return out;
  }

  // 「自分の案件／共有された案件」。初期表示は自分の案件
  var currentTab = 'own';
  function setTab(tab) {
    currentTab = tab === 'shared' ? 'shared' : 'own';
    if (!modal) return;
    Array.prototype.forEach.call(modal.querySelectorAll('[data-qatp-tab]'), function (t) {
      var on = t.getAttribute('data-qatp-tab') === currentTab;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    filterProjects();
  }

  function filterProjects() {
    if (!modal) return;
    var list = modal.querySelector('[data-qatp-list]');
    var filterEl = modal.querySelector('[data-qatp-filter]');
    var statusEl = modal.querySelector('[data-qatp-status]');
    var query = normalizeSearch(String(filterEl ? filterEl.value : '').trim());
    var tabsEl = modal.querySelector('[data-qatp-tabs]');
    var tabOn = tabsEl && !tabsEl.hidden;
    var st = statusEl ? statusEl.value : '';
    var buttons = list.querySelectorAll('.qatp-project');
    var shown = 0;
    Array.prototype.forEach.call(buttons, function (b) {
      var okQ = !query || (b.getAttribute('data-search') || '').indexOf(query) !== -1;
      var okS = !st || b.getAttribute('data-status') === st;
      var okT = !tabOn || (b.getAttribute('data-mine') === 'true') === (currentTab === 'own');
      var match = okQ && okS && okT;
      b.hidden = !match;
      if (match) shown++;
    });
    var noMatch = list.querySelector('[data-qatp-nomatch]');
    if ((query || st || tabOn) && shown === 0) {
      if (!noMatch) {
        noMatch = document.createElement('p');
        noMatch.className = 'qatp-hint';
        noMatch.setAttribute('data-qatp-nomatch', '');
        noMatch.textContent = '条件に合う案件がありません';
        list.appendChild(noMatch);
      }
      noMatch.hidden = false;
    } else if (noMatch) {
      noMatch.hidden = true;
    }
  }

  function open() {
    ensureModal();
    // ゲスト表示(openGuest)で隠した要素を戻す
    var sub = modal.querySelector('.qatp-sub');
    var nw = modal.querySelector('.qatp-new');
    if (sub) sub.hidden = false;
    if (nw) nw.hidden = false;
    modal.hidden = false;
    loadProjects();
  }

  // 未ログイン時＝一覧の取得は行わず、ログインへの案内だけを出す（課題: 「読み込みに失敗しました」と出ていた）
  function openGuest() {
    ensureModal();
    var list = modal.querySelector('[data-qatp-list]');
    var sub = modal.querySelector('.qatp-sub');
    var nw = modal.querySelector('.qatp-new');
    var controls = modal.querySelector('[data-qatp-controls]');
    var note = modal.querySelector('[data-qatp-note]');
    if (sub) sub.hidden = true;
    if (nw) nw.hidden = true;
    if (controls) controls.hidden = true;
    if (note) note.hidden = true;
    var returnTo = encodeURIComponent(window.location.pathname + window.location.search);
    list.innerHTML =
      '<p class="qatp-hint">案件に追加するにはログインが必要です。</p>' +
      '<p style="margin:10px 0 4px"><a class="qatp-login" href="/customer_authentication/login?return_to=' + returnTo + '">ログインして案件に追加</a></p>';
    modal.hidden = false;
  }

  function close() { if (modal) modal.hidden = true; }

  function toast(msg) {
    var t = document.createElement('div');
    t.className = 'qatp-toast';
    t.textContent = msg;
    document.body.appendChild(t);
    setTimeout(function () { if (t.parentNode) t.parentNode.removeChild(t); }, 2600);
  }

  function loadProjects() {
    var list = modal.querySelector('[data-qatp-list]');
    var filter = modal.querySelector('[data-qatp-filter]');
    var statusSel = modal.querySelector('[data-qatp-status]');
    var controls0 = modal.querySelector('[data-qatp-controls]');
    // CB260910⑦: 開くたびに絞り込みを初期化（前回の条件が残っていると「案件が無い」ように見える）
    if (filter) filter.value = '';
    if (statusSel) statusSel.value = '';
    currentTab = 'own';
    if (controls0) controls0.hidden = true;
    list.innerHTML = '<p class="qatp-hint">読み込み中...</p>';
    fetch(API, { credentials: 'same-origin' })
      .then(function (res) {
        if (res.status === 401) { window.location.href = '/account/login'; return null; }
        return res.json();
      })
      .then(function (d) {
        if (!d || goProfileIfRequired(d)) return;
        var projects = d.projects || [];
        var note = modal.querySelector('[data-qatp-note]');
        // CB260910⑦: 「直近50件」の注記＝51件目以降は検索しても出てこないので隠さない
        if (note) {
          note.textContent = d.truncated
            ? '更新の新しい50件を表示しています。見つからない場合は案件一覧から追加してください。'
            : '';
          note.hidden = !d.truncated;
        }
        if (!projects.length) { list.innerHTML = '<p class="qatp-hint">案件がまだありません。下で新規作成してください。</p>'; return; }
        list.innerHTML = projects.map(function (p) {
          // 状態ラベルと作成者名はサーバーが組み立てて返す（①には作成者名が空で返る）
          var parts = [];
          if (p.customer_name) parts.push(p.customer_name);
          if (p.status_label) parts.push(p.status_label);
          if (p.owner_name) parts.push(p.owner_name);
          var meta = parts.join(' · ');
          // 会社名（作成者の会員情報）も検索対象に。全角/半角・かな/カナの違いは normalizeSearch で吸収
          // S32-25: 担当ASP営業の氏名（assignee_search・検索専用で表示しない）も検索対象に
          var hay = normalizeSearch([p.title, p.customer_name, p.owner_name, p.owner_company, p.assignee_search].join(' '));
          return '<button type="button" class="qatp-project" data-id="' + esc(p.id) + '"' +
            ' data-status="' + esc(p.status || '') + '" data-mine="' + (p.is_mine ? 'true' : 'false') + '" data-search="' + esc(hay) + '">' +
            esc(p.title) +
            (meta ? '<span class="qatp-project-meta">' + esc(meta) + '</span>' : '') +
            '</button>';
        }).join('');
        Array.prototype.forEach.call(list.querySelectorAll('.qatp-project'), function (b) {
          b.addEventListener('click', function () { addToProject(b.getAttribute('data-id'), b); });
        });
        // 案件が複数あるときだけ絞り込みUIを表示
        var controls = modal.querySelector('[data-qatp-controls]');
        if (controls) controls.hidden = projects.length < 2;
        var ownCount = projects.filter(function (p) { return p.is_mine; }).length;
        var sharedCount = projects.length - ownCount;
        var tabs = modal.querySelector('[data-qatp-tabs]');
        if (tabs) {
          tabs.hidden = sharedCount === 0;
          tabs.querySelector('[data-qatp-tab-count="own"]').textContent = '(' + ownCount + ')';
          tabs.querySelector('[data-qatp-tab-count="shared"]').textContent = '(' + sharedCount + ')';
          // タブがあるときは件数が少なくても絞り込みを出す（タブ内で探せるように）
          if (controls && !tabs.hidden) controls.hidden = false;
        }
        setTab('own');
      })
      .catch(function () { list.innerHTML = '<p class="qatp-hint">読み込みに失敗しました</p>'; });
  }

  function addToProject(projectId, btn) {
    if (!current || !current.handle) { toast('商品情報を取得できませんでした'); return; }
    if (btn) btn.disabled = true;
    fetch('/products/' + encodeURIComponent(current.handle) + '.json', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var prod = (d && d.product) || d || {};
        var v = (prod.variants && prod.variants[0]) || {};
        // CB260917: ランクS＝別途見積＝「価格を持たない」。Shopifyのバリアント価格には
        // （並び替えのために）実価格が入ることがあるので、案件明細へは常に 0 を送る。
        // 0＝別途見積 は見積アプリ・家具リスト・原本の計算式が見ている値なので変えない。
        var isQuoteRank = [v.option1, v.option2, v.option3].some(function (o) {
          return String(o || '').indexOf('別途見積') >= 0;
        });
        var price = isQuoteRank
          ? 0
          : ((v.price != null && v.price !== '') ? Number(String(v.price).replace(/,/g, '')) : null);
        return fetch(API + '/' + encodeURIComponent(projectId) + '/items', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({
            shopify_product_id: current.productId || prod.id || null,
            shopify_variant_id: v.id || null,
            title: current.title || prod.title || '商品',
            sku: v.sku || '',
            brand: prod.vendor || '',
            quantity: 1,
            unit_price: price,
            image_url: current.image || '',
            product_handle: current.handle,
            color: '', upholstery: '', note: ''
          })
        });
      })
      .then(function (res) { return res.json().then(function (d) { return { ok: res.ok, d: d }; }); })
      .then(function (r) {
        if (goProfileIfRequired(r.d)) return;
        if (!r.ok) throw new Error((r.d && r.d.error) || '追加に失敗しました');
        close();
        toast('案件に追加しました');
      })
      .catch(function (e) { if (btn) btn.disabled = false; toast(e.message || '追加に失敗しました'); });
  }

  function createAndAdd() {
    var inp = modal.querySelector('[data-qatp-new-name]');
    var name = (inp.value || '').trim();
    if (!name) { inp.focus(); return; }
    fetch(API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ title: name })
    })
      .then(function (res) {
        if (res.status === 401) { window.location.href = '/account/login'; return null; }
        return res.json().then(function (d) { return { ok: res.ok, d: d }; });
      })
      .then(function (r) {
        if (!r || goProfileIfRequired(r.d)) return;
        if (!r.ok || !r.d.project) throw new Error((r.d && r.d.error) || '作成に失敗しました');
        addToProject(r.d.project.id, null);
      })
      .catch(function (e) { toast(e.message || '作成に失敗しました'); });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-project-add]') : null;
    if (!btn) return;
    e.preventDefault();
    // 未ログイン＝APIを呼ばずにログイン案内（呼ぶと「読み込みに失敗しました」になる）
    if (!btn.getAttribute('data-logged-in')) { openGuest(); return; }
    // 価格マトリクス商品＝構成なしでは価格が決まらないためクイック追加不可→商品ページで仕様選択してもらう
    if (btn.getAttribute('data-requires-config')) {
      ensureModal(); // toast用CSSの注入（モーダル自体は開かない）
      toast('この商品は仕様の選択が必要です。商品ページに移動します…');
      var url = btn.getAttribute('data-product-url') || ('/products/' + (btn.getAttribute('data-handle') || ''));
      setTimeout(function () { window.location.href = url; }, 900);
      return;
    }
    current = {
      productId: btn.getAttribute('data-product-id') || '',
      handle: btn.getAttribute('data-handle') || '',
      title: btn.getAttribute('data-title') || '',
      image: btn.getAttribute('data-image') || ''
    };
    open();
  });
})();
